export default __webpack_public_path__ + "e868196c87de902c7ac737c4e2e6aae8.png";